<div class="d-flex flex-column h-100">
  <div class="scroll-sidebar" [class.has-button]="Service.type !== 'all'">
    <ul
      *ngIf="initServiceType === 'all' && allMessengersService.arServicesAuthorized?.length > 1"
      id="menu-social"
      class="menu-social-horizontal navbar-round nav navbar-nav justify-content-center py-0 px-4 px-lg-5 mt-4"
      role="tablist"
    >
      <li
        [class.active]="item.type === Service.type"
        *ngFor="let item of allMessengersService.arServicesAuthorized; let i = index"
        class="nav-item outline-none"
        (click)="toggleService(item)"
      >
        <app-avatar
          [Service]="item"
          [id]="item.arProfile?.id"
          [type]="'private'"
          [avatar]="item.arProfile?.avatar"
          [avatarFileId]="item.arProfile?.avatar_file_id"
          [avatarFileUniqueId]="item.arProfile?.avatar_file_unique_id"
          [serviceType]="item.type"
          [force]="true"
          class="d-inline-block avatar avatar-sm mx-2"
        >
        </app-avatar>
      </li>
    </ul>
    <app-error-show
      (onReload)="reloadProfile()"
      [Service]="Service"
      [error]="Service.isLoadedProfileError"
      *ngIf="Service.isLoadedProfileError"
      class="h-100"
    ></app-error-show>
    <div [formGroup]="settingsService.Form" class="container-fluid py-6">
      <div *ngIf="Service.arProfile?.id" class="card mb-6">
        <div class="card-body">
          <div class="text-center py-6">
            <!-- Photo -->
            <ng-template [ngIf]="Service.isLoadedProfile && Service.arProfile?.name" [ngIfElse]="loaderProfile">
              <app-profile-avatar [Service]="Service" (reloadProfile)="reloadProfile()"></app-profile-avatar>

              <ng-template [ngIf]="!isEditProfile">
                <h5>
                <span
                  [innerHTML]="
                    Service.arProfile?.name?.first + ' ' + Service.arProfile?.name?.last
                      | replaceEmojis: 'facebook':20:64
                  "
                ></span>
                  &nbsp;<i-feather (click)="toggleEditProfile()" [style.margin-top.px]="-6"
                                   name="edit"
                                   class="ml-auto icon-md pointer"></i-feather>
                </h5>
                <p
                  *ngIf="Service.arProfile?.description"
                  class="text-muted"
                  [innerHTML]="Service.arProfile.description | replaceEmojis: 'facebook':20:64"
                ></p>
              </ng-template>

              <button *ngIf="Service.type === 'telegram'" class="btn btn-sm btn-outline-primary" type="button" (click)="openSpamBot()">Написать в @SpamBot</button>

              <div [class.hidden]="!isEditProfile" class="edit-profile__form">
                <nz-input-group nzCompact class="mb-3">
                  <input nz-input placeholder="Имя" style="width: 40%;" [(ngModel)]="Service.arProfile.name.first"
                         [ngModelOptions]="{standalone: true}" class="edit-profile__name"/>
                  <input nz-input placeholder="Фамилия" style="width: 60%;" [(ngModel)]="Service.arProfile.name.last"
                         [ngModelOptions]="{standalone: true}" class="edit-profile__lastname"/>
                </nz-input-group>
                <nz-input-group class="mb-3">
                <textarea autosize rows="2" nz-input [placeholder]="descriptionPlacehilder"
                          [ngModelOptions]="{standalone: true}"
                          [(ngModel)]="Service.arProfile.description"></textarea>
                </nz-input-group>

                <button (click)="editProfile()" [nzLoading]="isSavingProfile" nz-button nzType="primary" nzBlock>
                  Сохранить&nbsp;<i-feather name="save" class="icon-md align-top"></i-feather>
                </button>
              </div>


            </ng-template>
            <ng-template #loaderProfile>
              <div class="text-center my-8">
                <nz-space-item>
                  <nz-skeleton-element
                    class="rounded-circle overflow-hidden"
                    nzType="image"
                    [nzActive]="true"
                  ></nz-skeleton-element>
                </nz-space-item>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <!-- Card -->
      <!-- Card -->
      <!--
							{
							"first_name": "Александр",
							"id": 115086755,
							"last_name": "Трубкин",
							"home_town": "Кострома",
							"status": "Я всех имел, а на нее смотрел",
							"bdate": "26.8.1993",
							"bdate_visibility": 1,
							"city": {
							"id": 71,
							"title": "Кострома"
							},
							"country": {
							"id": 1,
							"title": "Россия"
							},
							"phone": "+7 *** *** ** 67",
							"relation": 7,
							"screen_name": "cosangeles",
							"sex": 2,
							"name": {
							"first": "Александр",
							"last": "Трубкин"
							},
							"phone_number": "+7 *** *** ** 67",
							"username": "cosangeles"
							}
							phone: {wa_version: "2.21.3.19", mcc: "250", mnc: "032", os_version: "10", device_manufacturer: "Xiaomi",…}
			device_manufacturer: "Xiaomi"
			device_model: "merlinnfc"
							-->

      <div class="card mb-6">
        <div *ngIf="Service.arProfile?.id" class="card-body">
          <ul class="list-group list-group-flush">
            <app-profile-username [Service]="Service"></app-profile-username>
            <li
              *ngIf="Service.arProfile?.phone_number && Service.arProfile.phone_number !== 'None'"
              class="list-group-item py-3"
            >
              <div class="media align-items-center">
                <div class="media-body">
                  <p class="small text-muted mb-0">Телефон</p>
                  <p>
                    <a href="tel:{{ Service.arProfile.phone_number }}">{{ Service.arProfile.phone_number }}</a>
                  </p>
                </div>
                <i-feather name="phone-call" class="text-muted"></i-feather>
              </div>
            </li>
            <li
              *ngIf="Service.type !== 'fellowdesk'"
              class="list-group-item py-3"
            >
              <div class="media align-items-center">
                <div class="media-body">
                  <p class="small text-muted mb-0">Внутренний номер аккаунта</p>
                </div>
                <span
                  class="chat-service-type">
                      <img
                        loading="lazy"
                        class="title-type"
                        width="30"
                        height="30"
                        title="Номер аккаунта"
                        src="/assets/icons/socials/{{ Service.type | fixType }}-empty.svg"
                        alt=""/>
                      <i>{{ Service.type | serviceNumber }}</i>
                    </span>
              </div>
            </li>
            <li *ngIf="Service.arProfile?.phone?.device_manufacturer" class="list-group-item py-3">
              <div class="media align-items-center">
                <div class="media-body">
                  <p class="small text-muted mb-0">Устройство</p>
                  <p class="mb-2">
                    {{ Service.arProfile?.phone?.device_manufacturer }} ({{ Service.arProfile?.phone?.device_model }})
                  </p>
                  <ng-template [ngIf]="Service.arProfile?.batterylevel">
                    <p class="small text-muted mb-0">
                      Уровень заряда
                      <span *ngIf="Service.arProfile?.batteryLastTime">{{
                        Service.arProfile.batteryLastTime | timeago
                        }}</span>
                    </p>
                    <p>{{ Service.arProfile?.batterylevel }}%</p>
                  </ng-template>
                  <ng-template [ngIf]="Service.arProfile?.phone?.mcc == 250">
                    <p class="small text-muted mb-0">Провайдер</p>
                    <small>{{ nmc['25' + Service.arProfile?.phone?.mnc] }}</small>
                  </ng-template>
                </div>
                <app-battery-indicator [Service]="Service"></app-battery-indicator>
              </div>
            </li>
            <li *ngIf="Service.arProfile.personal_url" class="list-group-item py-3">
              <div class="media align-items-center">
                <div class="media-body">
                  <p class="small text-muted mb-0">Личная ссылка</p>
                  <p>
                    <a target="_blank"
                       href="{{ Service.arProfile.personal_url }}">{{ Service.arProfile.personal_url }}</a>
                  </p>
                </div>
                <i-feather name="external-link" class="text-muted"></i-feather>
              </div>
            </li>
            <li *ngIf="Service.arProfile.organization" class="list-group-item py-3">
              <div class="media align-items-center">
                <div class="media-body">
                  <p class="small text-muted mb-0">Организация</p>
                  <p>
                    {{ Service.arProfile.organization }}
                  </p>
                  <p class="small text-muted mb-0">Организационная единица</p>
                  <p>
                    {{ Service.arProfile.organization_unit }}
                  </p>
                </div>
                <i-feather name="users" class="text-muted"></i-feather>
              </div>
            </li>
            <li *ngIf="Service.arProfile?.city?.title" class="list-group-item py-3">
              <div class="media align-items-center">
                <div class="media-body">
                  <p class="small text-muted mb-0">Местоположение</p>
                  <p>
                    <ng-template [ngIf]="Service.arProfile?.country?.title">
                      {{ Service.arProfile?.country?.title }},
                    </ng-template>
                    {{ Service.arProfile?.city?.title }} {{Service.arProfile?.street}}
                  </p>
                </div>
                <i-feather name="map-pin" class="text-muted"></i-feather>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- Card -->
      <!-- Card -->
      <div class="card mb-6">
        <div class="card-body">
          <ul class="list-group list-group-flush">
            <li class="list-group-item py-3">
              <div class="media align-items-center">
                <div class="media-body">
                  <div class="row no-gutters align-items-center">
                    <!-- Title -->
                    <div class="col">
                      <h5>Общие настройки</h5>
                    </div>
                    <!-- Icon -->
                    <div class="col-auto">
                      <i-feather name="settings" class="text-muted icon-md"></i-feather>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li *ngIf="allService.isElectron() && false" class="list-group-item py-3">
              <div class="media align-items-center">
                <div class="media-body">
                  <div class="d-flex justify-content-between mb-2">
                    <!-- Title -->
                    <h6 class="mb-0">Сервер разработки</h6>
                    <!-- Switch -->
                    <div class="custom-control custom-switch">
                      <input
                        formControlName="dev"
                        checked
                        type="checkbox"
                        class="custom-control-input"
                        id="switch-dev-mode"
                      />
                      <label class="custom-control-label" for="switch-dev-mode"></label>
                    </div>
                  </div>
                  <small class="text-muted">Режим работы приложения.</small>
                </div>
              </div>
            </li>
            <li *ngIf="allService.isElectron() && false" class="list-group-item py-3">
              <div class="media align-items-center">
                <div class="media-body">
                  <div class="d-flex justify-content-between mb-2">
                    <!-- Title -->
                    <h6 class="mb-0">Системный Title Bar?</h6>
                    <!-- Switch -->
                    <div class="custom-control custom-switch">
                      <input
                        formControlName="title"
                        value="dark"
                        checked
                        type="checkbox"
                        class="custom-control-input"
                        id="switch-theme-title"
                      />
                      <label class="custom-control-label" for="switch-theme-title"></label>
                    </div>
                  </div>
                  <small class="text-muted"
                  >Возвращает верхнюю часть приложения в системный режим, для расширения функций.</small
                  >
                </div>
              </div>
            </li>
            <li class="list-group-item py-3">
              <div class="media align-items-center">
                <div class="media-body">
                  <div class="d-flex justify-content-between mb-2">
                    <!-- Title -->
                    <h6 class="mb-0">Темная тема</h6>
                    <!-- Switch -->
                    <div class="custom-control custom-switch">
                      <input
                        formControlName="theme"
                        [(ngModel)]="themeService.theme"
                        value="dark"
                        checked
                        type="checkbox"
                        class="custom-control-input"
                        id="custom-switch-theme"
                      />
                      <label class="custom-control-label" for="custom-switch-theme"></label>
                    </div>
                  </div>
                  <small class="text-muted">Для сохранения заряда или ночью.</small>
                </div>
              </div>
            </li>
            <li class="list-group-item py-3">
              <div class="media align-items-center">
                <div class="media-body">
                  <div class="d-flex justify-content-between mb-2">
                    <!-- Title -->
                    <h6 class="mb-0">Компактный режим</h6>
                    <!-- Switch -->
                    <div class="custom-control custom-switch">
                      <input
                        formControlName="compact"
                        [(ngModel)]="themeService.compact"
                        value="true"
                        checked
                        type="checkbox"
                        class="custom-control-input"
                        id="custom-switch-compact"
                      />
                      <label class="custom-control-label" for="custom-switch-compact"></label>
                    </div>
                  </div>
                  <small class="text-muted">Включить компактный режим для списка чатов.</small>
                </div>
              </div>
            </li>
            <li *ngIf="settingsService?.arConfig?.font_size?.value" class="list-group-item py-3">
              <div class="media align-items-center">
                <div class="media-body">
                  <div class="d-flex justify-content-between mb-2">
                    <!-- Title -->
                    <h6 class="mb-0">Размер шрифта</h6>
                    <!-- Switch -->
                    <div class="custom-control">
                      <select
                        class="form-control"
                        formControlName="font_size"
                        [(ngModel)]="settingsService.arConfig.font_size.value"
                      >
                        <option value="80">80%</option>
                        <option value="90">90%</option>
                        <option value="100">100%</option>
                        <option value="110">110%</option>
                        <option value="120">120%</option>
                        <option value="130">130%</option>
                        <option value="140">140%</option>
                        <option value="1850">150%</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="card mb-6">
        <div class="card-body">
          <ul class="list-group list-group-flush">
            <li class="list-group-item py-3">
              <div class="media align-items-center">
                <div class="media-body">
                  <div class="row no-gutters align-items-center">
                    <!-- Title -->
                    <div class="col">
                      <h5>Тема</h5>
                    </div>
                    <!-- Icon -->
                    <div class="col-auto">
                      <i-feather name="bell" class="text-muted icon-md"></i-feather>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li *ngIf="false" class="list-group-item py-3">
              <div class="">
                <div class="">
                  <div class="mb-2">
                    <!-- Title -->
                    <h6 class="mb-0 text-muted">Фоновые изображения</h6>
                    <!--<nz-upload (nzChange)="themeService.handleChangeImage($event)">
																					<button nz-button>
																						Добавить картинку
																					</button>
																				</nz-upload>-->
                    <div [ngStyle]="{ 'min-height': '100px' }">
                      <div class="my-3">
                        <carousel [cellWidth]="60" [height]="50">
                          <div
                            *ngFor="let img of themeService.backgroundThemeList; let i = index"
                            [class.active]="img.active"
                            class="carousel-cell backgroundItem"
                          >
                            <img
                              loading="lazy"
                              (click)="setBackground(i)"
                              [src]="img.src"
                              class="img-prev rounded-circle"
                              alt=""
                            />
                          </div>
                        </carousel>
                      </div>
                    </div>
                  </div>
                  <small class="text-muted">Отметьте понравившиеся изображения, они будут сменяться.</small>
                  <h6 (deferVizible)="isInit = true; cd.detectChanges()" class="mb-0">Размытие фона</h6>
                  <!--<div *ngIf="isInit">
																			<nz-slider [nzMin]="0" [nzMax]="1000" [(ngModel)]="themeService.blur" (ngModelChange)="themeService.blurChange($event)"></nz-slider>

																			<nz-slider [nzMarks]="marks" [ngModel]="37"></nz-slider>
																		</div>-->
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- Card -->
      <div class="card mb-6">
        <div class="card-body">
          <ul class="list-group list-group-flush">
            <li class="list-group-item py-3">
              <div class="media align-items-center">
                <div class="media-body">
                  <div class="row no-gutters align-items-center">
                    <!-- Title -->
                    <div class="col">
                      <h5>Сообщения</h5>
                    </div>
                    <!-- Icon -->
                    <div class="col-auto">
                      <i-feather name="bell" class="text-muted icon-md"></i-feather>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="list-group-item py-3">
              <div class="media align-items-center">
                <div class="media-body">
                  <div class="d-flex justify-content-between mb-2">
                    <!-- Title -->
                    <h6 class="mb-0">Читать сообщения по кнопке</h6>
                    <!-- Switch -->
                    <div class="custom-control custom-switch">
                      <input
                        formControlName="read_btn"
                        checked
                        type="checkbox"
                        class="custom-control-input"
                        id="config-read"
                      />
                      <label class="custom-control-label" for="config-read"></label>
                    </div>
                  </div>
                  <small class="text-muted">Для прочтения переписки, не отмечая прочитанным.</small>
                </div>
              </div>
            </li>
            <li class="list-group-item py-3">
              <div class="media align-items-center">
                <div class="media-body">
                  <div class="d-flex justify-content-between mb-2">
                    <!-- Title -->
                    <h6 class="mb-0">Отображение уведомлений</h6>

                    <!-- Switch -->
                    <div class="custom-control custom-switch">
                      <input
                        formControlName="message_show"
                        checked
                        type="checkbox"
                        class="custom-control-input"
                        id="custom-switch-4"
                      />
                      <label class="custom-control-label" for="custom-switch-4"></label>
                    </div>
                  </div>
                  <small class="text-muted">Уведомление о новом сообщении.</small>
                </div>
              </div>
            </li>
            <li class="list-group-item py-3">
              <div class="media align-items-center">
                <div class="media-body">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <!-- Title -->
                    <h6 class="mb-0">Звук</h6>

                    <!-- Switch -->
                    <div class="custom-control custom-switch">
                      <input
                        formControlName="message_sound"
                        checked
                        type="checkbox"
                        class="custom-control-input"
                        id="custom-switch-1"
                      />
                      <label class="custom-control-label" for="custom-switch-1"></label>
                    </div>
                  </div>
                  <small class="text-muted">Проигрывать звук при уведомлении?</small>
                </div>
              </div>
            </li>
            <li class="list-group-item py-3">
              <div class="media align-items-center">
                <div class="media-body">
                  <div class="d-flex justify-content-between mb-2">
                    <!-- Title -->
                    <h6 class="mb-0">Текст сообщения</h6>

                    <!-- Switch -->
                    <div class="custom-control custom-switch">
                      <input
                        formControlName="message_show_text"
                        checked
                        type="checkbox"
                        class="custom-control-input"
                        id="custom-switch-3"
                      />
                      <label class="custom-control-label" for="custom-switch-3"></label>
                    </div>
                  </div>
                  <small class="text-muted text-center">Показывать текст сообщения в уведомлении?</small>
                </div>
              </div>
            </li>
          </ul>
          <!--<div class="text-muted text-center small">{{ allService.token }}</div>-->
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="Service.type !== 'all'" class="py-6 sidebar-footer">
    <div class="container-fluid">
      <!-- Card -->
      <div class="form-row">
        <!--<div class="col">
									<button (mousemove)="allService.effectMouseMove($event)" type="button" class="effectMouse btn btn-lg btn-block btn-basic d-flex align-items-center">
										Настройки
										<i-feather name="settings" class="ml-auto icon-md align-middle"></i-feather>
									</button>
								</div>-->

        <div class="col">
          <!-- Button -->
          <button
            (mousemove)="allService.effectMouseMove($event)"
            (click)="logout()"
            type="button"
            class="effectMouse effect-white btn btn-lg btn-block btn-basic btn-danger d-flex align-items-center"
          >
            Выйти
            <i-feather name="log-out" class="ml-auto icon-md align-middle"></i-feather>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
